module.exports = __webpack_public_path__ + "img/2-7-6.3931f663.png";